import BaseService from './baseService';

export default {
    getCategoria() {
      return BaseService.get("dominio/categoria");
    },
    getEstado() {
      return BaseService.get("dominio/uf");
    },
    getCidade(model) {
      return BaseService.post("dominio/municipio", model);
    },
    getSituacaoSolicitacao() {
      return BaseService.get("dominio/situacoessolicitacao");
    },
    getCombosDadosBasicos() {
      return BaseService.get("dominio/getCombosDadosBasicos");
    },
    geEnums() {
      return BaseService.get("dominio/enums");
    },
    getPontuacaoIndices() {
      return BaseService.get("dominio/pontuacaoindices");
    },
    getListaDocsQualificacaoTecnica(arrayFamilias) {
      return BaseService.post("dominio/listaDocsQualificacaoTecnica", arrayFamilias);
    },
    getTodasUnidades(){
      return BaseService.get(`dominio/todasunidades`);
    },
  };
